import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme, miniPlayer }) => ({
  position: 'absolute',
  right: miniPlayer ? theme.margin.small : theme.margin.large,
  textAlign: 'right',
  top: miniPlayer ? theme.margin.small : theme.margin.large,
});

const TopRight = ({ miniPlayer, children }) => {
  const { css } = useFela({ miniPlayer });

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

TopRight.propTypes = {
  miniPlayer: PropTypes.bool,
  children: PropTypes.node,
};

export default React.memo(TopRight);
